// Opening external pages (Stripe Checkout, Stripe Connect onboarding).
// Web/PWA: same-tab navigation (Stripe returns to our success URL).
// Native: in-app browser (Custom Tabs / SFSafariViewController) — Stripe
// Checkout should not run inside the app WebView. When the user closes it we
// route to a page that asks the server for the authoritative status.

import { Browser } from '@capacitor/browser';
import { isNative } from './platform';

export async function openExternal(url: string, onClosed?: () => void): Promise<void> {
  if (isNative()) {
    if (onClosed) {
      const handle = await Browser.addListener('browserFinished', () => {
        void handle.remove();
        onClosed();
      });
    }
    await Browser.open({ url, presentationStyle: 'popover' });
    return;
  }
  window.location.assign(url);
}

export async function closeExternal(): Promise<void> {
  if (isNative()) await Browser.close().catch(() => undefined);
}
